import { makeAuthedRequest } from "utils/makeAuthedRequest";
import { useQuery } from "react-query";
import env from "../../environment";

export function useReportsGet(params) {
  const {
    ibo,
    year,
    month,
    // Fields for majorEvent
    event,
    attendees,
    location,
    // Fields for membership
    type,
    status,
    // Type selector
    reportType,
  } = params;
  
  const queryKey =
    reportType === "major"
      ? ["majorEvent", ibo, event, year, month, attendees, location]
      : ["membership", ibo, year, month, type, status];

  const endpoint =
    reportType === "major"
      ? `/reports/major-events/ibo/${ibo}/event/${event}/year/${year}/month/${month}/attendees/${attendees}/location/${location}`
      : `/reports/membership/ibo/${ibo}/year/${year}/month/${month}/type/${type}/status/${status}`;

  const { data, isLoading, refetch } = useQuery(
    queryKey,
    () =>
      makeAuthedRequest(endpoint, { method: "GET" }, env.apiBaseNew).then(
        async (res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error((await res.json()).message);
          }
        }
      ),
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      cacheTime: Infinity,
    }
  );

  return { data, isLoading, refetch };
}
